<script>
import axios from 'axios'
import Vue from 'vue'
export default {
	async beforeRouteEnter(to, from, next) {
		try {
			let { data } = await axios.post(`${to.fullPath}`)
			Vue.prototype.$notify(data.message, 'success')
			next(data.showUrl)
		} catch ({ response }) {
			Vue.prototype.$notify(response.data.message)
			if (response.data.showUrl) next(response.data.showUrl)
			else next('/')
		}
	},
}
</script>
